import script from "./invoice-wtdk-2-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-wtdk-2-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__